/**
 * @description The reasons why KYC verification is required for a transaction.
 */
export enum KycRequirementReasonType {
  ForeignIpRestriction = 'ForeignIpRestriction'
}



// WEBPACK FOOTER //
// ./src/model/types/kyc-requirement-reason-type.ts